import { Component } from '@angular/core';

@Component({
  selector: 'procure-ai-badge',
  template: 'AI',
  styleUrl: './ai-badge.component.scss',
})
export class AIBadge {}
